import { render } from "./VideoRef.vue?vue&type=template&id=72576fd2&scoped=true"
import script from "./VideoRef.vue?vue&type=script&lang=js"
export * from "./VideoRef.vue?vue&type=script&lang=js"

import "./VideoRef.vue?vue&type=style&index=0&id=72576fd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72576fd2"]])

export default __exports__